import isEqual from 'lodash/isEqual';
import {
    useSsSelector,
} from '~SpectateStore';
import {
    selectSelectionName,
    selectSelectionIsBetable,
    selectSortedSelectionsIds,
    selectSelectionDecimalPrice,
    selectSelectionFractionPrice,
    selectSelectionAmericanPrice,
    selectMarketHasSelections,
    selectUiMarketHasSelections,
    selectGameLineSelectionsIds,
    selectSelectionSpecialOddsValue,
    selectSelectionType,
    selectGoalscorerSelectionsIds,
    selectSelectionHomeScore,
    selectSelectionAwayScore,
} from '~SpectateStore/selectors/selectionsSelectors';

export const useSelectionName = id => useSsSelector(state => selectSelectionName(state, id));
export const useSelectionDecimalPrice = id => useSsSelector(state => selectSelectionDecimalPrice(state, id));
export const useSelectionFractionPrice = id => useSsSelector(state => selectSelectionFractionPrice(state, id));
export const useSelectionAmericanPrice = id => useSsSelector(state => selectSelectionAmericanPrice(state, id));
export const useSelectionIsBetable = id => useSsSelector(state => selectSelectionIsBetable(state, id));
export const useSelectionSpecialOddsValue = id => useSsSelector(state => selectSelectionSpecialOddsValue(state, id));
export const useSelectionType = id => useSsSelector(state => selectSelectionType(state, id));
export const useSortedSelectionsIds = (eventId, marketId) => useSsSelector(state => selectSortedSelectionsIds(state, eventId, marketId), isEqual);
export const useMarketHasSelections = (eventId, marketId) => useSsSelector(state => selectMarketHasSelections(state, eventId, marketId));
export const useUiMarketHasSelections = (eventId, marketId) => useSsSelector(state => selectUiMarketHasSelections(state, eventId, marketId));
export const useGameLineSelectionsIds = (eventId, marketId, headers) => useSsSelector(state => selectGameLineSelectionsIds(state, eventId, marketId, headers), isEqual);
export const useGoalscorerSelectionsIds = (eventId, uiMarketId) => useSsSelector(state => selectGoalscorerSelectionsIds(state, uiMarketId, eventId), isEqual);
export const useSelectionHomeScore = id => useSsSelector(state => selectSelectionHomeScore(state, id));
export const useSelectionAwayScore = id => useSsSelector(state => selectSelectionAwayScore(state, id));
